// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#243b4e","colorPrimaryLight5":"#929da7","colorPrimaryLight7":"#bdc4ca","colorPrimaryLight9":"#e9ebed"};